import Model, { attr, belongsTo, hasMany } from '@ember-data/model'

export default class TimingDeviceModel extends Model 
{
	@attr name;
}